/**
 * Letter + background for public profile / modal when no photo (same algorithm as backend
 * `controllers/trader/leaderboard-bots.js` getAvatarColor / getFirstLetter).
 */

const AVATAR_COLORS = [
  "#E0FFFF",
  "#F0F8FF",
  "#F5FFFA",
  "#FAEBD7",
  "#FFF0F5",
  "#FFFFF0",
  "#FDF5E6",
  "#FFFAF0",
  "#FAFAD2",
  "#FFDAB9",
  "#FFC0CB",
  "#F0E68C",
  "#E6E6FA",
  "#D8BFD8",
  "#ADD8E6",
  "#90EE90",
  "#B0E0E6",
  "#C0C0C0",
  "#D3D3D3",
  "#F5F5DC",
] as const;

export function getProfileLetterAvatarColor(displayName: string | null | undefined): string {
  const key = displayName != null ? String(displayName).trim() : "";
  if (!key) return AVATAR_COLORS[0];
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  const colorIndex = Math.abs(hash) % AVATAR_COLORS.length;
  return AVATAR_COLORS[colorIndex];
}

export function getProfileLetterAvatarLetter(displayName: string | null | undefined): string {
  if (displayName == null || String(displayName).trim() === "") return "?";
  const cleanName = String(displayName).replace(/_/g, " ").trim();
  return cleanName.charAt(0).toUpperCase() || "?";
}
